import React, { useLayoutEffect, useState } from "react";
import { GetWebsite } from "../queries/get-website";
import { cn } from "../util";

/** Same breakpoint as `gallery.js` (`innerWidth < 768` → mobile). */
const MOBILE_BREAKPOINT_PX = 768;

const Footer = () => {
  const { Contact } = GetWebsite();

  const [isMobileWidth, setIsMobileWidth] = useState(false);

  useLayoutEffect(() => {
    if (typeof window === "undefined") return;
    const update = () => {
      setIsMobileWidth(window.innerWidth < MOBILE_BREAKPOINT_PX);
    };
    update();
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);

  return (
    <footer className={cn("pointer-events-none")}>
      <a
        href={`mailto:${Contact.Email}`}
        className={cn(
          "pointer-events-auto hidden xl:fixed xl:bottom-0 xl:left-0 xl:z-40 xl:block xl:pl-2.5 xl:pb-2.5"
        )}
      >
        {Contact.email}
      </a>
      <div
        className={cn(
          "pointer-events-none fixed inset-x-0 bottom-0 z-40 flex items-end justify-end px-2.5 pb-2.5",
          isMobileWidth && "hidden"
        )}
      >
        <span className="pointer-events-auto text-xs leading-none">
          © {new Date().getFullYear()}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
